import { Injectable } from '@angular/core';
import { Observable, Subscription, take } from 'rxjs';
import { AppState, selectAuthState, selectPermisosState, selectOperacionState, selectDetalleFacturaState } from '../store/app.states';
import { Store } from '@ngrx/store';
import { NgxIndexedDB } from 'ngx-indexed-db';
import { environment } from '../../environments/environment';
import { IOperacion } from 'app/interfaces/interfaces';
import { AsignarOperacion } from 'app/store/actions/operacion.actions';
import { DetalleFactura } from 'app/store/actions/detalleFactura.actions';

@Injectable({
  providedIn: 'root'
})
export class BaseService {
  private idxCOAL: NgxIndexedDB;
  private stateAuth: Observable<any>;
  private stateSecu: Observable<any>;
  private SeguridadSubscribe: Subscription;
  private AutenticacionSubscribe: Subscription;
  private detalleFacturaSubscribe: Subscription;
  private stateOperacion: Observable<any>;
  private OperacionSubscribe: Subscription;
  private stateDetalleFactura: Observable<any>;
  constructor(private store: Store<AppState>) {
    this.stateReduxStore();
    this.idxCOAL = new NgxIndexedDB(environment.nombreAplicacion, 1);
  }

  private stateReduxStore() {
    this.stateAuth = this.store.select(selectAuthState);
    this.stateSecu = this.store.select(selectPermisosState);
    this.stateOperacion = this.store.select( selectOperacionState );
    this.stateDetalleFactura = this.store.select(selectDetalleFacturaState);
  }

  /**
   * Solo obtiene los datos del usuario y destruye la suscripción, es para datos que no requieren que este un observable
  */
  public getUserData() {
    let usuario;
    this.AutenticacionSubscribe = this.stateAuth.subscribe(state => {
      usuario = state.seguridad;
    });
    this.AutenticacionSubscribe.unsubscribe();
    return usuario;
  }


  /**
   * Solo obtiene los datos de la seguridad y destruye la suscripción, es para datos que no requieren que este un observable
  */
  public getSecurityData() {
    let seguridad;
    this.SeguridadSubscribe = this.stateSecu.pipe(take(1)).subscribe(state => {
        seguridad = state;
    });

    //this.SeguridadSubscribe.unsubscribe();
    return seguridad;
  }

  public postOperacionData( operacion: IOperacion ){
    this.store.dispatch( new AsignarOperacion({
        ...operacion
    }));

    this.ActualizaIndexDB()
  }

  ActualizaIndexDB() {
    let operacionData = this.getOperacionData();
    this.idxCOAL.openDatabase(1).then(() => {
      this.idxCOAL.getByKey('seguridad', 1).then(resultado => {

        this.idxCOAL?.update('seguridad', {
          ...resultado,
          operacion: operacionData
        })
      })
    })
  }

  public getDataDB(){
    this.idxCOAL.openDatabase(1).then(() => {
      this.idxCOAL.getByKey('seguridad', 1).then(resultado => {
        this.store.dispatch( new AsignarOperacion( resultado.operacion ))


      })
    })
  }

  public getOperacionData() {
    let operacion;
    this.OperacionSubscribe = this.stateOperacion.subscribe(state => {
      operacion = state;
    })
    this.OperacionSubscribe.unsubscribe();
    return operacion;
  }

  public getDataDetalleFactura() {
    let detalleFactura;
    this.detalleFacturaSubscribe = this.stateDetalleFactura.subscribe(state => {
      detalleFactura = state;
    })
    this.detalleFacturaSubscribe.unsubscribe();
    return detalleFactura;
  }

  public postDetalleFactura(params) {
    let detalleFacturaData = this.getDataDetalleFactura();
    this.store.dispatch(DetalleFactura({
      ...detalleFacturaData,
      params,
    }))
    // this.UpdateIndexDBdetalleFactura(params)
  }

//   public postDetalleFacturaLimpiar() {
//     // let detalleFacturaData = this.getDataDetalleFactura();
//     this.store.dispatch(DetalleFacturaLimpiar())
//     // this.UpdateIndexDBdetalleFactura(params)
//   }
}
